module.exports = __webpack_public_path__ + "img/family_top.185d1650.png";